import { destroy, post, put } from '../../../../api/axios';
import { AccountantManagementEndpoints } from '../../../../api/endpoints/AccountantManagementEndpoints';
import { InvitationEndpoints } from '../../../../api/endpoints/InvitationEndpoints';
import { type InvitationDto } from '../../../models/InvitationDto';
import { type InvitationCreateRequestDto } from '@/app/models/InvitationCreateRequestDto';
import { type TaskInfoDto } from '../../../models/TaskInfoDto';
import { type FiscalSpedRequestDto } from '../../../models/FiscalSpedRequestDto';
import {
  type AccountantChangePasswordRequestDto,
  type AccountantDashboardFilterRequestDto,
  type AccountantDashboardMetricsDto,
} from './_models';

export const createInvitation = (payload: InvitationCreateRequestDto) => {
  return post<InvitationDto>(InvitationEndpoints.add, payload);
};

export const resendInvitation = (id: string) => {
  return put<void>(InvitationEndpoints.resend(id), {});
};

export const cancelInvitation = (id: string) => {
  return put<void>(InvitationEndpoints.cancel(id), {});
};

export const removeInvitation = (id: string) => {
  return destroy<void>(InvitationEndpoints.delete(id));
};

export const getAccountantDashboardMetrics = (payload: AccountantDashboardFilterRequestDto) => {
  return post<AccountantDashboardMetricsDto>(AccountantManagementEndpoints.dashboardMetrics, payload);
};

export const generateInvoicesPdf = (payload: AccountantDashboardFilterRequestDto) => {
  return post<TaskInfoDto<string>>(AccountantManagementEndpoints.generateInvoicesPdf, payload);
};

export const generateSpedFiscal = (payload: FiscalSpedRequestDto) => {
  return post<TaskInfoDto<string>>(AccountantManagementEndpoints.generateSpedFiscal, payload);
};

export const toggleAccountantAccessStatus = (id: string) => {
  return post(AccountantManagementEndpoints.toggleAccessStatus(id));
};

export const removeAccountantAccess = (id: string) => {
  return destroy(AccountantManagementEndpoints.removeAccess(id));
};

export const changeAccountantAccessPassword = (id: string, payload: AccountantChangePasswordRequestDto) => {
  return post(AccountantManagementEndpoints.changePassword(id), payload);
};
